import { motion, useMotionValue } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { openLink } from "utils/openLink";
import EmergentLogo from "static/images/AuthTestimonial/CompanyList/Emergent.png";
import WritesonicLogo from "static/images/AuthTestimonial/CompanyList/Writesonic.png";
import MailmodoLogo from "static/images/AuthTestimonial/CompanyList/Mailmodo.png";
import ZokoLogo from "static/images/AuthTestimonial/CompanyList/Zoko.png";
import PlotlineLogo from "static/images/AuthTestimonial/CompanyList/Plotline.png";
import ParahelpLogo from "static/images/AuthTestimonial/CompanyList/Parahelp.png";
import TheResidencyLogo from "static/images/AuthTestimonial/CompanyList/TheResidency.png";
import SuperAGILogo from "static/images/AuthTestimonial/CompanyList/SuperAGI.png";
import CapiLogo from "static/images/AuthTestimonial/CompanyList/Capi.png";
import PortkeyLogo from "static/images/AuthTestimonial/CompanyList/Portkey.png";
import SprintoLogo from "static/images/AuthTestimonial/CompanyList/Sprinto.png";
import MudrexLogo from "static/images/AuthTestimonial/CompanyList/Mudrex.png";
import HaticaLogo from "static/images/AuthTestimonial/CompanyList/Hatica.png";
import SpendFloLogo from "static/images/AuthTestimonial/CompanyList/SpendFlo.png";
import System2Logo from "static/images/AuthTestimonial/CompanyList/System.png";
import CrustdataLogo from "static/images/AuthTestimonial/CompanyList/Crustdata.png";
import DrivetrainLogo from "static/images/AuthTestimonial/CompanyList/Drivetrain.png";
import MagicStudioLogo from "static/images/AuthTestimonial/CompanyList/MagicStudio.png";
import PibitLogo from "static/images/AuthTestimonial/CompanyList/PibitAi.png";

import EmergentMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Emergent.png";
import WritesonicMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Writesonic.png";
import MailmodoMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Mailmodo.png";
import ZokoMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Zoko.png";
import PlotlineMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Plotline.png";
import ParahelpMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Parahelp.png";
import TheResidencyMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/TheResidency.png";
import SuperAGIMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/SuperAGI.png";
import CapiMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Capi.png";
import PortkeyMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Portkey.png";
import SprintoMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Sprinto.png";
import MudrexMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Mudrex.png";
import HaticaMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Hatica.png";
import SpendFloMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/SpendFlo.png";
import System2MobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/System.png";
import CrustdataMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Crustdata.png";
import DrivetrainMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Drivetrain.png";
import MagicStudioMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/MagicStudio.png";
import PibitMobileLogo from "static/images/AuthTestimonial/CompanyListForMobile/Pibit.png";
import { useWindowSize } from "hooks/useWindowSize";

type Company = {
  name: string;
  url: string;
  mobileImageUrl: string;
  imageUrl: string;
};

const COMPANIES: Company[] = [
  {
    name: "Spendflo",
    url: "https://www.spendflo.com/",
    mobileImageUrl: SpendFloMobileLogo,
    imageUrl: SpendFloLogo,
  },
  {
    name: "Emergent",
    url: "https://app.emergent.sh/landing/",
    mobileImageUrl: EmergentMobileLogo,
    imageUrl: EmergentLogo,
  },
  {
    name: "Zoko",
    url: "https://www.zoko.io/",
    mobileImageUrl: ZokoMobileLogo,
    imageUrl: ZokoLogo,
  },
  {
    name: "Crustdata",
    url: "https://crustdata.com/",
    mobileImageUrl: CrustdataMobileLogo,
    imageUrl: CrustdataLogo,
  },
  {
    name: "Capi",
    url: "https://capimoney.com/",
    mobileImageUrl: CapiMobileLogo,
    imageUrl: CapiLogo,
  },
  {
    name: "Pibit",
    url: "https://www.pibit.ai/",
    mobileImageUrl: PibitMobileLogo,
    imageUrl: PibitLogo,
  },
  {
    name: "Mudrex",
    url: "https://mudrex.com/",
    mobileImageUrl: MudrexMobileLogo,
    imageUrl: MudrexLogo,
  },
  {
    name: "The Residency",
    url: "https://www.livetheresidency.com/",
    mobileImageUrl: TheResidencyMobileLogo,
    imageUrl: TheResidencyLogo,
  },
  {
    name: "Plotline",
    url: "https://www.plotline.so/",
    mobileImageUrl: PlotlineMobileLogo,
    imageUrl: PlotlineLogo,
  },
  {
    name: "Sprinto",
    url: "http://sprinto.in/",
    mobileImageUrl: SprintoMobileLogo,
    imageUrl: SprintoLogo,
  },
  {
    name: "System2",
    url: "https://www.sstm2.com/",
    mobileImageUrl: System2MobileLogo,
    imageUrl: System2Logo,
  },
  {
    name: "Hatica",
    url: "https://www.hatica.io/",
    mobileImageUrl: HaticaMobileLogo,
    imageUrl: HaticaLogo,
  },
  {
    name: "Writesonic",
    url: "https://writesonic.com/",
    mobileImageUrl: WritesonicMobileLogo,
    imageUrl: WritesonicLogo,
  },
  {
    name: "Magic Studio",
    url: "https://magicstudio.com",
    mobileImageUrl: MagicStudioMobileLogo,
    imageUrl: MagicStudioLogo,
  },
  {
    name: "SuperAGI",
    url: "https://superagi.com/",
    mobileImageUrl: SuperAGIMobileLogo,
    imageUrl: SuperAGILogo,
  },
  {
    name: "Drivetrain",
    url: "https://www.drivetrain.ai/",
    mobileImageUrl: DrivetrainMobileLogo,
    imageUrl: DrivetrainLogo,
  },
  {
    name: "Mailmodo",
    url: "https://www.mailmodo.com/",
    mobileImageUrl: MailmodoMobileLogo,
    imageUrl: MailmodoLogo,
  },
  {
    name: "Parahelp",
    url: "https://parahelp.com",
    mobileImageUrl: ParahelpMobileLogo,
    imageUrl: ParahelpLogo,
  },
  {
    name: "Portkey",
    url: "https://portkey.ai/",
    mobileImageUrl: PortkeyMobileLogo,
    imageUrl: PortkeyLogo,
  },
];

export const CompanyListFlow = () => {
  const { width, isMobile } = useWindowSize();
  const companies = [...COMPANIES, ...COMPANIES, ...COMPANIES, ...COMPANIES];
  const [isHovered, setIsHovered] = useState(false);
  const x = useMotionValue(0);
  const startTimeRef = useRef<number>(0);
  const pausedProgressRef = useRef<number>(0);

  useEffect(() => {
    const totalDistance = -50 * companies.length;
    const duration = 120 * 1000; // Convert to milliseconds
    let rafId: number;

    const animate = (timestamp: number) => {
      if (!startTimeRef.current) {
        startTimeRef.current = timestamp - pausedProgressRef.current * duration;
      }

      const elapsed = timestamp - startTimeRef.current;
      const progress = (elapsed / duration) % 1;
      const currentX = progress * totalDistance;

      x.set(currentX);
      pausedProgressRef.current = progress;

      if (!isHovered) {
        rafId = requestAnimationFrame(animate);
      }
    };

    if (!isHovered) {
      rafId = requestAnimationFrame(animate);
    } else {
      startTimeRef.current = 0;
    }

    return () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [isHovered, companies.length, x]);

  return (
    <div className="t-w-full t-overflow-hidden t-relative">
      <motion.div className="t-flex t-gap-[60px] t-items-end" style={{ x }}>
        {companies.map((company, index) => (
          <motion.div
            key={`${company.name}-${index}`}
            className="t-rounded-lg t-border t-cursor-pointer t-whitespace-nowrap t-select-none t-flex t-items-center t-gap-3"
            whileHover={{
              scale: 1.1,
            }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 20,
            }}
            role="button"
            onClick={() => openLink(company.url)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <img
              src={isMobile ? company.mobileImageUrl : company.imageUrl}
              alt={company.name}
            />
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};
